export default __webpack_public_path__ + "static/media/grupodpg124.293801e0.svg";